import React from 'react'
import PropTypes from 'prop-types'
import FormImage from 'components/forms/image/FormImage'

const FormBackgroundElement = ({
  isHorizontal,
  className,
  style,
  source,
  onChange,
}) => (
  <FormImage style={style} className={className}>
    <FormImage.Column width={isHorizontal ? 5 : 12}>
      <FormImage.Image
        src={source}
        alt="image"
        style={isHorizontal ? { width: '100%' } : {}}
      />
    </FormImage.Column>
    <FormImage.Column width={isHorizontal ? 7 : 12}>
      <FormImage.Source
        value={source}
        onChange={(val) => onChange(val)}
      />
    </FormImage.Column>
  </FormImage>
)

FormBackgroundElement.propTypes = {
  isHorizontal: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  source: PropTypes.string,
  onChange: PropTypes.func,
}
FormBackgroundElement.defaultProps = {
  isHorizontal: false,
  className: undefined,
  style: undefined,
  source: undefined,
  onChange: () => {},
}

export default FormBackgroundElement



// WEBPACK FOOTER //
// ./src/components/forms/image/FormBackgroundImage.js